<template>
  <div name="outcomecourse" class="h-screen overflow-y-auto">

    <transition name="fade">
      <div class="loading" v-show="loading">
        <span class="fa fa-spinner fa-spin"></span> Loading units
      </div>
    </transition>

    <div v-if="errored" class="empty">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <table class="table-wrapper" v-if="componentLoaded">
      <thead class="text-left text-xs bg-gray-100 w-full h-6 opacity-50">
        <th class="w-1.5 p-2">Year</th>
        <th class="w-11/12 pl-3">Unit Title</th>
        <th class="w-1.5 pl-3">Select</th>
      </thead>

      <tbody>
        <tr
          v-for="course in orderedUnits"
          :key="course.id"
          class="course list-complete-item"
          v-bind:class="isSchoolType(course) ? 'text-pink-red' : ''"
        >
          <td class="w-1.5 text-center">
            <span class=""> {{ getYearLetter(course.year_id) }}</span>
          </td>
          <td class="w-3/12 text-xs">
            <span class="pl-3 font-bold">{{ course.name }}</span>
          </td>
          <td class="w-1.5">
            <button
              type="button"
              @click="selectCourse(course)"
              class="rounded-xl my-1 mr-1 w-10 h-8 cursor-pointer focus:outline-none hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue"
              v-bind:class="[
                containsCourse(course)
                  ? 'bg-action-blue bg-opacity-75 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
            >
              <i
                class="text-base far"
                v-bind:class="
                  containsCourse(course) ? 'fa-check-circle' : 'fa-circle'
                "
              ></i>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot></tfoot>
    </table>
    <p class="ml-10 mt-6 text-sm" v-else>
      We could not find any data for your given selection.
    </p>

  </div>
</template> 

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { SchoolService } from "@/services/school.service";

export default {
  name: "outcomecourse",
  props: {
    subject:  { type: Object, required: false },
    years: {type: Array, required: false},
    outcomeUnitsSelected: {type: Array, required: false},
    selectedYears: {type: Array, required: false},
  },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    orderedUnits() {
      if (this.selectedYears == null) {
        return _.orderBy(this.units, ["year_id", "name"]);
      } else {
        var vm = this;

        var filtered = this.units.filter(function (unit) {
          let filtered = true;
        // filtered = unit.active === 1;
          if (filtered) {
            filtered = vm.selectedYears.includes(unit.year_id);
          }
          return filtered;
        });

        return _.orderBy(filtered, ["year_id", "name"]);
      }
    },
    componentLoaded() {
      return this.orderedUnits.length > 0;
    },
  },
  watch: {
    selectedYears: function (newVal, oldVal) {
      // watch it
      //console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      //this.filterUnitList();
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      units: [],
      currentTab: 1,
      unitsSelected: this.outcomeUnitsSelected,
      highLessonCount: 0,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      SchoolService.getAll("courses/subject/" + this.subject.id +"?visibility=private&state=all")
        .then((response) => this.buildUnitList(response.data.data))
        .catch((err) => {
          console.log("Courses " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildUnitList(data) {
      this.units = data;

      let date = moment().subtract(2, "years");

      SchoolService.getAll("planning?since=" + moment(date, "YYYY-MM-DD"))
        .then((response) => {
          let planning = response.data.data;
        
          let results = planning.flatMap((element) => {
            if (element.is_deleted === 0 && element.display_box > 0) {
              return element.course;
            }
          });

          var joinedResults = this.units.concat(results.filter((u) => u != undefined))
          let coursesMapped = new Map();
          for(const course of joinedResults) {
            coursesMapped.set(course.id, course);
          }

          this.units = [...coursesMapped.values()]
        })
        .catch((err) => {
          console.log("Courses " + err);
          this.errored = true;
        });
    },
    isSchoolType(course) {
      return (course.type_id === 3 || (course.type != undefined && course.type.id === 3))
    },
    getYearLetter(yearId) {
      var year = this.years.find((y) => y.id === yearId);
      return year != undefined ? year.letter : "N/A";
    },
    containsCourse(course) {
      return this.unitsSelected.includes(course.id);
    },
    selectCourse(course) {
      let result = this.containsCourse(course);
      if (result === true) {
        let index = this.unitsSelected.indexOf(course.id);
        if (index > -1) {
          this.unitsSelected.splice(index, 1);
        }
      } else {
        this.unitsSelected.push(course.id);
      }
    },
  },
  components: {},
};
</script> 


<style scoped>
table td {
  padding-top: 0.5em !important;
  padding-bottom: 0.5em !important;
}
</style>
